import React, { useState } from "react";
import { tutorRows } from "./data";
import SectionHead from "./SectionHead";
import MarqueePauseButton from "../../../common/MarqueePauseButton";

const Cast = () => {
  const [paused, setPaused] = useState(false);

  return (
    <section
      className={`cast${paused ? " is-paused" : ""}`}
      aria-labelledby="cast-title"
    >
      <div className="wrap">
        <SectionHead
          number="07"
          title="And the"
          emphasis="rotating cast."
          id="cast-title"
        />
        <p className="cast-intro">
          Almost all our tutors share one thing: they still do the job.{" "}
          <strong>Working practitioners, not retired academics.</strong> You
          learn from the people making the moves, not the ones writing papers
          about them.
        </p>
      </div>
      <div
        className="marquee-container"
        aria-label="Selected tutors who teach on 42courses"
      >
        {tutorRows.map((row, index) => (
          <div
            className={`marquee-row${index === 1 ? " reverse slow" : ""}`}
            key={index}
          >
            {[...row, ...row, ...row].map((tutor, tutorIndex) => (
              <div className="tutor-chip" key={`${tutor.name}-${tutorIndex}`}>
                <span className="tutor-name">{tutor.name}</span>
                <span className="tutor-title">{tutor.title}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="cast-controls">
        <MarqueePauseButton
          paused={paused}
          onToggle={() => setPaused(!paused)}
        />
      </div>
      <div className="wrap">
        <p className="cast-footer">
          And several dozen more. We would list them all, but you would be here
          until Tuesday.
        </p>
      </div>
    </section>
  );
};

export default Cast;
